import axios from 'axios';
import qs from 'qs';

export const getQuizById = ({
  lessonId,
  locale,
}: {
  lessonId: string;
  locale?: string;
}) =>
  axios.get(
    `/api/v1/quizzes/${lessonId}${locale ? `?${qs.stringify({ locale })}` : ''}`,
  );

export const createQuiz = (data: any) => axios.post('/api/v1/quizzes', data);

export const updateQuizById = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: any;
}) => axios.put(`/api/v1/quizzes/${lessonId}`, data);

export const removeQuizById = (quizId: string) =>
  axios.delete(`/api/v1/quizzes/${quizId}`);
